import { IconAccordionProps } from "./types"
import React from "react"
import { Accordion } from "~widgets/accordion"
import Icon from "~widgets/icon"
import styled from '~/ui/styled'

const LeftIconWrap = styled.Pressable`
  margin-right: 10px;
`

const IconAccordion: React.FC<IconAccordionProps> = ({
  accordionProps,
  iconProps,
  onIconPress,
  children,
}) => {
  return (
    <Accordion {...accordionProps}>
      <LeftIconWrap onClick={() => onIconPress?.()}>
        <Icon name="rightArrow" color="#999" size={20} {...iconProps} />
      </LeftIconWrap>
      {children}
    </Accordion>
  )
}
export default IconAccordion
